import { render, staticRenderFns } from "./StudioProductPrivateSessions.vue?vue&type=template&id=70fbc6b6&scoped=true&"
import script from "./StudioProductPrivateSessions.vue?vue&type=script&lang=js&"
export * from "./StudioProductPrivateSessions.vue?vue&type=script&lang=js&"
import style0 from "./StudioProductPrivateSessions.vue?vue&type=style&index=0&id=70fbc6b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fbc6b6",
  null
  
)

export default component.exports